export default "__VITE_ASSET__Bq9oiy3A__"